export default "__VITE_ASSET__1028cf54__"